import React, { useEffect, useState } from 'react';
import { CaptionText } from '@prisjakt/ui/text/variants';
import { CheckboxSwitch } from '@prisjakt/ui/checkbox/variants';
import { FilterType } from 'src/components/price-list/types';
import { FilterOptionWrapper, CheckboxClickarea } from '../styles';

type Props = {
  optionId: string;
  defaultValue: boolean;
  label?: string;
  caption?: string;
  filterType: FilterType;
  onChange: (filterType: FilterType) => void;
};

export const FilterOption = (props: Props) => {
  const { optionId, defaultValue, onChange, label, caption } = props;
  const [isChecked, setIsChecked] = useState(defaultValue);

  useEffect(() => {
    if (defaultValue !== isChecked) {
      setIsChecked(defaultValue);
    }
  }, [defaultValue]);

  const onChangeHandler = (e?: React.ChangeEvent<HTMLInputElement>) => {
    e?.preventDefault();
    const newVal = !isChecked;
    setIsChecked(newVal);
    onChange(props.filterType);
  };

  return (
    <FilterOptionWrapper>
      <CheckboxClickarea>
        <CheckboxSwitch
          id={optionId}
          text={label}
          onChange={() => onChangeHandler()}
          checked={isChecked}
        />
        {caption && <CaptionText container="div">{caption}</CaptionText>}
      </CheckboxClickarea>
    </FilterOptionWrapper>
  );
};
